module.exports = __webpack_public_path__ + "static/media/unico.abef7f7b.png";